import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UploadButtonService } from './aon-upload-button.service';
import { FileUploader } from 'ng2-file-upload';
import { DialogService } from "../../../commons/core/utils/dialog.service";

@Component({
	selector: 'n9-upload-button',
	templateUrl: './aon-upload-button.component.html'
})
export class AonUploadButtonComponent implements OnInit {

	@Input()
	public extension: string;

	@Input()
	public fileType: string;

	@Input()
	public website: string;

	@Output()
	public success: EventEmitter<any> = new EventEmitter();

	public uploader: FileUploader;

	private _url: string;
	private _language: string;

	get url(): string {
		return this._url;
	}

	@Input('url')
	set url(url: string) {
		this._url = url;
		this.initUploader();
	}

	get language(): string {
		return this._language;
	}

	@Input('language')
	set language(language: string) {
		this._language = language;
		this.uploadButtonService.setLanguage(this._language);
	}

	public constructor(
		private uploadButtonService: UploadButtonService,
		private dialogService: DialogService
	) {}

	public ngOnInit(): void {
		this.initUploader();
	}

	public selectUploadFile(): void {
		this.uploadButtonService.selectUploadFile(
			this.extension,
			this.uploader
		);
	}

	private initUploader(): void {
		this.uploader = this.uploadButtonService.initUploader(this.url);
		this.uploader.onSuccessItem = () => {
			this.success.emit(null);
			this.dialogService.confirmModal('Import successful');
		};
		this.uploadButtonService.setFileType(this.fileType);
	}

}
